import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';
import { getHomeRoute } from '../config/roles';
import { isPendingBrokerCompany } from '../config/brokerAccess';

/**
 * A wrapper component that protects routes by authentication and optional role authorization.
 * @param {string[]} [allowedRoles] - If provided, only users with one of these roles may access the route.
 */
const ProtectedRoute = ({ children, allowedRoles }) => {
  const location = useLocation();
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const user = useAppSelector((state) => state.auth.user);

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Fail closed: missing/unknown role must not bypass role gates.
  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    return <Navigate to={getHomeRoute(user?.role)} replace />;
  }

  // Pending broker companies may only use Quick Pricer until approved (role already validated above).
  if (
    user?.role &&
    isPendingBrokerCompany(user?.brokerCompanyStatus) &&
    location.pathname.startsWith('/broker') &&
    !location.pathname.startsWith('/broker/scenario-pricer')
  ) {
    return <Navigate to="/broker/scenario-pricer" replace />;
  }

  return children;
};

export default ProtectedRoute;
